module.exports = __webpack_public_path__ + "img/benefit-icon_people.4cd4bc95.svg";